/**
 * @ngdoc service
 * @name cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
 * @restrict E
 * @scope
 * @description Servizio che gestisce il processo di creazione nuova pratica e
 *              visualizzazione pratica esistente
 */
(function () {
  angular.module('cbl.cartadebitoint.wa').service('CdintPropostaCartaDebitoIntSrvc', [
    '$http',
    'CdintUserSrvc',
    'CdintMessaggiFctr',
    'CDINT_CONSTANTS',
    'CdintLabelSrvc',
    function ($http, userSrvc, messaggiFctr, CONSTANTS, labelSrvc) {
      this.$http = $http;
      (this.userSrvc = userSrvc), (this.messaggiFctr = messaggiFctr);
      this.labelSrvc = labelSrvc;
      this.CONSTANTS = CONSTANTS;

      /**
       * Variabile per la gestione dello spinner
       */
      this.spinner = { showSpinner: 0 };

      /**
       * Dati della pratica, presenti anche nel componente cdintPropostaCartaDebitoInt
       */
      this.datiPratica;

      /**
       * ndg della richiesta
       */
      this.ndg;

      /**
       * Dati valorizzati per il primo step "cdintDefinizione" della specializzazione Small Business
       */
      this.datiDefinizioneSB;

      /**
       * Dati valorizzati per il secondo step "cdintDatiAggiuntivi" della specializzazione Light
       */
      this.datiAggiuntivi;

      /**
       * Dati valorizzati per il secondo step, primo sottostep "cdintDatiAggiuntiviPg"
       * della specializzazione small business (persona giuridica)
       */
      this.datiAggiuntiviPg;

      /**
       * Dati valorizzati per il secondo step, secondo sottostep "cdintDatiAggiuntiviPf"
       * della specializzazione small business (persona fisica)
       */
      this.datiAggiuntiviPf;

      /**
       * Dati valorizzati per il terzo step "cdintQuestionari"
       */
      this.questionari;

      /**
       * rappresenta il tipo Carta che è stato settato
       * per default è N per la light mentre per consumer e sb, preso da fe
       */
      this.currentTipoCarta;

      /**
       * Flag che indica se è in corso un redirect della pagina per visualizzare uno spinner speciale nell'intestazione
       */
      this.isRedirecting = false;

      /**
       * Riferimento interno
       */
      var self = this;

      /**
       * Utility di formattazione date
       */
      this.millisToDate = function (milliseconds) {
        var data = new Date(milliseconds);

        if (!data) {
          return null;
        }

        var day = data.getDate();
        var month = data.getMonth() + 1;
        var year = data.getFullYear();

        return (
          (day < 10 ? '0' + day.toString() : day.toString()) +
          '/' +
          (month < 10 ? '0' + month.toString() : month.toString()) +
          '/' +
          year.toString()
        );
      };

      /**
       * Utility per separare il numero civico dall'indirizzo
       */
      this.civicoDaIndirizzo = function (indirizzo) {
        if (!(indirizzo && indirizzo.trim().length > 0)) {
          return null;
        }

        // split per ' ' (spazio)
        var viaSplit = indirizzo.split(' ');
        var splitIndex = -1;

        for (var i = 0; i < viaSplit.length; i++) {
          if (!isNaN(viaSplit[i])) {
            splitIndex = indirizzo.indexOf(viaSplit[i]);
            break;
          }
        }

        if (splitIndex >= 0) {
          return indirizzo.substring(splitIndex);
        }

        // split per ','
        viaSplit = indirizzo.split(',');
        splitIndex = -1;

        for (var i = 0; i < viaSplit.length; i++) {
          if (!isNaN(viaSplit[i])) {
            splitIndex = indirizzo.indexOf(viaSplit[i]);
            break;
          }
        }

        if (splitIndex >= 0) {
          return indirizzo.substring(splitIndex);
        }

        return null;
      };

      /**
       * Indica se la pratica è in sola lettura
       */
      this.praticaIsReadOnly = function () {
        if (!self.datiPratica) {
          return true;
        }

        //EMonetica-437
        if (self.isCanaleBancaCloud()) {
          return true;
        }

        //QUID-138
        //Se il canale della pratica è promotore e il canale dello userProfile è filiale return true
        //console.log("Canale pratica " + self.datiPratica.canale + " Canale UP " + self.userSrvc.user.app)
        if (self.checkCanale(self.datiPratica.canale, self.userSrvc.user.app)) {
          if (
            self.datiPratica.stato == CONSTANTS.STATO_PRATICA.IN_CORSO ||
            self.datiPratica.stato == CONSTANTS.STATO_PRATICA.CONSOLIDATA ||
            self.datiPratica.stato == CONSTANTS.STATO_PRATICA.DAREVISIONARE
          ) {
            return true;
          }
        }

        switch (self.datiPratica.stato) {
          case CONSTANTS.STATO_PRATICA.ACCETTATA:
          case CONSTANTS.STATO_PRATICA.PRESENTATA:
          case CONSTANTS.STATO_PRATICA.ANNULLATA:
          case CONSTANTS.STATO_PRATICA.RIFIUTATA:
            return true;
          default:
            return false;
        }
      };

      this.checkCanale = function (canalePratica, canaleUP) {
        return (
          canalePratica.toUpperCase() == CONSTANTS.CANALE.PROMOTORE &&
          canaleUP.toUpperCase() == CONSTANTS.CANALE.FILIALE
        );
      };

      this.isCanaleBancaCloud = function () {
        if (
          self.datiPratica.canale &&
          (self.datiPratica.stato == CONSTANTS.STATO_PRATICA.IN_CORSO ||
            self.datiPratica.stato == CONSTANTS.STATO_PRATICA.CONSOLIDATA)
        ) {
          return self.datiPratica.canale.toUpperCase() == CONSTANTS.CANALE.BANCACLOUD;
        }
      };

      /**
       * Funzione di default chiamata in caso di salva o prosegui per resettare l'indirizzo di spedizione.
       */
      this.copiaIndirizzoResidenzaInSpedizione = function () {
        // funzione sovrascritta da controller.
      };

      /**
       * Funzione di default assegnata alla gestione abilitazione pulsante indietro. Viene reimpostata ad ogni passaggio di stato
       */
      this.defaultIndietroAbilitato = function () {
        return true;
      };

      /**
       * Funzione di default assegnata alla gestione visualizzazione salvataggio. Viene reimpostata ad ogni passaggio di stato
       */
      this.defaultSalvaVisibile = function () {
        return true;
      };

      /**
       * Funzione di default assegnata alla gestione visualizzazione salvataggio. Viene reimpostata ad ogni passaggio di stato
       */
      this.defaultProseguiVisibile = function () {
        return true;
      };

      /**
       * Funzione di default assegnata alla gestione visualizzazione prendi in carico. Viene reimpostata ad ogni passaggio di stato
       */
      this.defaultPrendiInCaricoVisibile = function () {
        return false;
      };

      /**
       * Funzione di default assegnata alla gestione visualizzazione rilascia pratica. Viene reimpostata ad ogni passaggio di stato
       */
      this.defaultRilasciaPraticaVisibile = function () {
        return false;
      };

      /**
       * Funzione di default assegnata alla gestione abilitazione salvataggio. Viene reimpostata ad ogni passaggio di stato
       */
      this.defaultSalvaAbilitato = function () {
        return false;
      };

      /**
       * Funzione di default assegnata alla gestione abilitazione proseguimento. Viene reimpostata ad ogni passaggio di stato
       */
      this.defaultProseguiAbilitato = function () {
        return false;
      };

      /**
       * Questa variabile ospita la funzione che abilita o meno il pulsante "indietro" nel componente cdintPropostaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default permette di tornare indietro
       */
      this.indietroAbilitato = this.defaultIndietroAbilitato;

      /**
       * Questa variabile ospita la funzione che visualizza o meno il pulsante "salva" nel componente cdintPropostaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default non permette il salvataggio
       */
      this.salvaVisibile = this.defaultSalvaVisibile;

      /**
       * Questa variabile ospita la funzione che visualizza o meno il pulsante "prosegui" nel componente cdintPropostaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default non permette di preseguire
       */
      this.proseguiVisibile = this.defaultProseguiVisibile;

      /**
       * Questa variabile ospita la funzione che visualizza o meno il pulsante "prendi in carico" nel componente cdintPropostaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default non permette di prendere in carico
       */
      this.prendiInCaricoVisibile = this.defaultPrendiInCaricoVisibile;

      /**
       * Questa variabile ospita la funzione che visualizza o meno il pulsante "prendi in carico" nel componente cdintPropostaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default non permette di prendere in carico
       */
      this.rilasciaPraticaVisibile = this.defaultRilasciaPraticaVisibile;

      /**
       * Questa variabile ospita la funzione che visualizza o meno il pulsante "completa" nel componente cdintPropostaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default non permette di completare
       */
      this.completaVisibile = function () {
        if (!self.datiPratica) {
          return false;
        }

        //QUID-138
        if (self.datiPratica.canale == 'BRIO_PROMOTORE' && self.userSrvc.user.app == 'filiale') {
          return false;
        }

        switch (self.datiPratica.stato) {
          case CONSTANTS.STATO_PRATICA.ACCETTATA:
          case CONSTANTS.STATO_PRATICA.ANNULLATA:
          case CONSTANTS.STATO_PRATICA.IN_CORSO:
            return false;
          case CONSTANTS.STATO_PRATICA.CONSOLIDATA:
          case CONSTANTS.STATO_PRATICA.PRESENTATA:
            return true;
          default:
            return false;
        }
      };

      this.rifiutaVisibile = function () {
        if (!self.datiPratica) {
          return false;
        }

        switch (self.datiPratica.stato) {
          case CONSTANTS.STATO_PRATICA.ACCETTATA:
          case CONSTANTS.STATO_PRATICA.ANNULLATA:
          case CONSTANTS.STATO_PRATICA.IN_CORSO:
          case CONSTANTS.STATO_PRATICA.CONSOLIDATA:
            return false;
          case CONSTANTS.STATO_PRATICA.PRESENTATA:
            return true;
          default:
            return false;
        }
      };

      /**
       * Questa variabile ospita la funzione che abilita o meno il pulsante "salva" nel componente cdintPropostaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default non permette il salvataggio
       */
      this.salvaAbilitato = this.defaultSalvaAbilitato;

      /**
       * Questa variabile ospita la funzione che abilita o meno il pulsante "prosegui" nel componente cdintPropostaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default non permette l'avanzamento
       */
      this.proseguiAbilitato = this.defaultProseguiAbilitato;

      /**
       * @ngdoc method
       * @name isPraticaNavigabile
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Verifica se lo stato della pratica permette la navigazione tramite click sui tab
       * @return {Boolean} - True se la pratica è navigabile, false in caso contrario
       */
      this.isPraticaNavigabile = function () {
        return self.praticaIsReadOnly();
      };

      /**
       * @ngdoc method
       * @name generaTabs
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Genera l'elenco delle tabs da visualizzare per la pratica
       * @return {Array} - Ritorna l'elenco delle tab disponibili per la pratica
       */
      this.generaTabs = function (datiPratica) {
        var tabs = [];

        tabs.push({
          step: 'DEFINIZIONE',
          label: 'label.tab.definizione',
          posizione: '1',
          statoPratica: [
            {
              stato: 'DAREVISIONARE',
              step: 1
            },
            {
              stato: 'INCORSO',
              step: 1
            }
          ],
          sottoStep: null
        });

        // Il tab dati aggiuntivi ha due sotto-step se la specializzazione è small business
        switch (datiPratica.specializzazione) {
          case CONSTANTS.SPECIALIZZAZIONI.SMALLBUSINESS:
            tabs.push({
              step: 'DATIAGGIUNTIVI',
              label: 'label.tab.datiAggiuntivi',
              posizione: '2',
              statoPratica: null,
              sottoStep: [
                {
                  step: 'DATIAGGIUNTIVIPG',
                  label: 'label.tab.datiAggiuntivi.personagiuridica',
                  posizione: '1',
                  statoPratica: [
                    {
                      stato: 'INCORSO',
                      step: 2
                    }
                  ]
                },
                {
                  step: 'DATIAGGIUNTIVIPF',
                  label: 'label.tab.datiAggiuntivi.personafisica',
                  posizione: '2',
                  statoPratica: [
                    {
                      stato: 'INCORSO',
                      step: 3
                    }
                  ]
                }
              ]
            });

            tabs.push({
              step: 'QUESTIONARI',
              label: 'label.tab.questionari',
              posizione: '3',
              statoPratica: [
                {
                  stato: 'INCORSO',
                  step: 4
                }
              ],
              sottoStep: null
            });
            break;
          case CONSTANTS.SPECIALIZZAZIONI.LIGHT:
            tabs.push({
              step: 'DATIAML',
              label: 'label.tab.datiAml',
              posizione: '2',
              statoPratica: [
                {
                  stato: 'INCORSO',
                  step: 2
                }
              ],
              sottoStep: null
            });
            tabs.push({
              step: 'QUESTIONARI',
              label: 'label.tab.questionari',
              posizione: '3',
              statoPratica: [
                {
                  stato: 'INCORSO',
                  step: 3
                }
              ],
              sottoStep: null
            });
            break;
          default:
            tabs.push({
              step: 'DATIAGGIUNTIVI',
              label: 'label.tab.datiAggiuntivi',
              posizione: '2',
              statoPratica: [
                {
                  stato: 'INCORSO',
                  step: 2
                }
              ],
              sottoStep: null
            });

            tabs.push({
              step: 'QUESTIONARI',
              label: 'label.tab.questionari',
              posizione: '3',
              statoPratica: [
                {
                  stato: 'INCORSO',
                  step: 3
                }
              ],
              sottoStep: null
            });
            break;
        }

        tabs.push({
          step: 'DOCUMENTI',
          label: 'label.tab.documenti',
          posizione: '4',
          statoPratica: [
            {
              stato: 'CONSOLIDATA',
              step: 1
            },
            {
              stato: 'CONSOLIDATA',
              step: 2
            },
            {
              stato: 'CONSOLIDATA',
              step: 3
            },
            {
              stato: 'CONSOLIDATA',
              step: 4
            },
            {
              stato: 'CONSOLIDATA',
              step: 5
            },
            {
              stato: 'CONSOLIDATA',
              step: 6
            },
            {
              stato: 'PRESENTATA',
              step: 1
            },
            {
              stato: 'PRESENTATA',
              step: 2
            },
            {
              stato: 'PRESENTATA',
              step: 3
            }
          ],
          sottoStep: null
        });

        return tabs;
      };

      /**
       * @ngdoc method
       * @name promiseCreaPratica
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per creare la pratica
       * @return {Promise} - Ritorna una promise contenente l'id della pratica appena creata
       */
      this.promiseCreaPratica = function (ndg, idProdotto, codiceBusta, iban, idTargetMarket, via, ndgUtilizzatore, datiDefinizione) {
        
    	  var dati = {    			  
    	  }
    	  dati = datiDefinizione;
    	  dati.ndg =  ndg;
    	  dati.idProdotto = idProdotto;
    	  dati.codiceBusta = codiceBusta;
    	  dati.iban = iban;
    	  dati.idTargetMarket = idTargetMarket;
    	  dati.ndgUtilizzatore = ndgUtilizzatore;
    	  
    	  return this.$http({
          method: 'POST',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.CREA,
          data: dati
        });
      };

      /**
       * @ngdoc method
       * @name promiseDettaglioProdotto
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per creare la pratica
       * @return {Promise} - Ritorna una promise contenente l'id della pratica appena creata
       */
      this.promiseDettaglioProdotto = function (ndg, idProdotto) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.CPT + ndg + '/' + idProdotto
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaDatiConto
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare i dati del conto corrente
       * @return {Promise} - Ritorna una promise contenente i dati del conto corrente
       */
      this.promiseRecuperaDatiConto = function (idPratica) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DATI_CONTO_CORRENTE + idPratica
        });
      };

      /**
       * @ngdoc method
       * @name promiseDettaglioPratica
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare il dettaglio pratoca
       * @return {Promise} - Ritorna una promise contenente l'oggetto pratica collegato all'ID
       */
      this.promiseDettaglioPratica = function (idPratica) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO + idPratica
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaContiCorrente
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare i conti corrente legati all'ndg indicato
       * @return {Promise} - Ritorna una promise contenente l'elenco dei conti corrente collegati all'ndg
       */
      this.promiseRecuperaContiCorrente = function (ndg) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.RICERCA.CONTICORRENTI + ndg + '/false'
          //                    ,
          //                    params: {
          //                        ndg: ndg
          //                    }
        });
      };
      
      this.promiseRicercaRapportiDelegati = function (ndg) {
          return this.$http({
            method: 'GET',
            url: CONSTANTS.REST_ROOT + CONSTANTS.REST.RICERCA.RAPPORTI_DELEGATI + ndg 
          });
        };

      /**
       * @ngdoc method
       * @name promiseRicercaCliente
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per ricercare le anagrafiche cliente in base ai parametri specificati
       * @return {Promise} - Ritorna una promise contenente l'elenco delle anagrafiche trovate in base ai parametri
       */
      this.promiseRicercaCliente = function (ndg, intestazione) {
    	  
	   var isRicercaEstesa = false;
	   if(self.userSrvc.user.app == 'brio'){
		   if(self.userSrvc.abilitazioni){
			   angular.forEach(self.userSrvc.abilitazioni, function (abilitazione, index) {
				   if (abilitazione.codice == "RicercaClientiEstesa") {
					   isRicercaEstesa = true;
				   }
			   });
		   }
	   }else if(self.userSrvc.user.app == 'filiale'){
		   isRicercaEstesa = true;
	   }
          
        var queryParamsObj = {
          almenoUnrapporto: false,
          codiceFiscale: '',
          codiceIdentita: '',
          cognome: '',
          intestazione: '',
          ndg: '',
          nome: '',
          partitaIva: '',
          ricercaEstesa: isRicercaEstesa,
          sottorete: true
        };

        if (ndg) {
          queryParamsObj.ndg = ndg;
        } else if (intestazione) {
          queryParamsObj.intestazione = intestazione;
        }

        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_CLIENTI_ROOT + CONSTANTS.REST.RICERCA.CLIENTI,
          params: queryParamsObj
        });
      };

      /**
       * @ngdoc method
       * @name promiseDefinizioneProdotto
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per eseguire la conferma del prodotto
       * @return {Promise} - Ritorna una promise contenente l'oggetto pratica collegato all'ID
       */
      this.promiseDefinizioneProdotto = function (idPratica, idProdotto, datiDefinizione, prosegui) {
        var dati = {
          idPratica: idPratica,
          // Recupero dal service, ma per default è nominativa
          tipoCarta: self.datiAggiuntivi && self.datiAggiuntivi.tipoCarta ? self.datiAggiuntivi.tipoCarta : 'I1',
          idProdotto: idProdotto
        };

        if (datiDefinizione && self.datiPratica.specializzazione === self.CONSTANTS.SPECIALIZZAZIONI.LIGHT) {
          // riprendo i dati
          dati = datiDefinizione;
          dati.ndgUtilizzatore = datiDefinizione.ndgUtilizzatore;
          dati.numeroRapporto = datiDefinizione.numeroRapporto;
          dati.iban = datiDefinizione.iban;
          dati.idPratica = idPratica;
          dati.idProdotto = idProdotto;
        }
        if (
          datiDefinizione &&
          self.datiPratica.specializzazione === self.CONSTANTS.SPECIALIZZAZIONI.SMALLBUSINESS &&
          datiDefinizione.tipoCarta === 'I2'
        ) {
          dati.ndgUtilizzatore = datiDefinizione.ndgUtilizzatore;
          dati.numeroRapporto = datiDefinizione.numeroRapporto;
          dati.iban = datiDefinizione.iban;
          dati.tipoCarta = datiDefinizione.tipoCarta;
          dati.codiceBusta = datiDefinizione.codiceBusta;
          dati.idPraticaConto = datiDefinizione.idPraticaConto;
        }
        if (
          datiDefinizione &&
          self.datiPratica.specializzazione === self.CONSTANTS.SPECIALIZZAZIONI.CONSUMER &&
          datiDefinizione.tipoCarta === 'I2'
        ) {
          dati.numeroRapporto = datiDefinizione.numeroRapporto;
          dati.iban = datiDefinizione.iban;
          dati.tipoCarta = datiDefinizione.tipoCarta;
          dati.codiceBusta = datiDefinizione.codiceBusta;
          dati.idPraticaConto = datiDefinizione.idPraticaConto;
        }

        if (
          datiDefinizione &&
          self.datiPratica.specializzazione === self.CONSTANTS.SPECIALIZZAZIONI.SMALLBUSINESS &&
          datiDefinizione.tipoCarta !== 'I2'
        ) {
          dati.ndgUtilizzatore = datiDefinizione.ndgUtilizzatore;
          dati.numeroRapporto = datiDefinizione.numeroRapporto;
          dati.iban = datiDefinizione.iban;
          dati.tipoCarta = datiDefinizione.tipoCarta;
          dati.codiceBusta = null;
          dati.idPraticaConto = datiDefinizione.idPraticaConto;
        }

        if (
          datiDefinizione &&
          self.datiPratica.specializzazione === self.CONSTANTS.SPECIALIZZAZIONI.CONSUMER &&
          datiDefinizione.tipoCarta !== 'I2'
        ) {
          dati.numeroRapporto = datiDefinizione.numeroRapporto;
          dati.iban = datiDefinizione.iban;
          dati.tipoCarta = datiDefinizione.tipoCarta;
          dati.codiceBusta = null;
          dati.idPraticaConto = datiDefinizione.idPraticaConto;
        }

        self.currentTipoCarta = dati.tipoCarta;

        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO + idPratica + CONSTANTS.REST.PRATICA.DEF_PRODOTTO,
          data: dati,
          params: {
            prosegui: prosegui
          }
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaAnagrafica
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare i dati dell'anagrafica della pratica
       * @return {Promise} - Ritorna una promise contenente l'oggetto anagrafica collegato alla pratica
       */
      this.promiseRecuperaAnagrafica = function (idPratica, recuperaUtilizzatore) {
        var queryParamsObj = {};

        if (recuperaUtilizzatore) {
          queryParamsObj.utilizzatore = recuperaUtilizzatore;
        }

        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.ANAGRAFICA.DETTAGLIO + idPratica,
          params: queryParamsObj
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaAnagraficaCoi
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare i dati dell'anagrafica della pratica
       * @return {Promise} - Ritorna una promise contenente la lista degli ndg anche delle COI
       */
      this.promiseRecuperaAnagraficaCoi = function (ndg) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.ANAGRAFICA.DETTAGLIO_COI + ndg
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaDominiEntiRilascio
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare i dati del dominio degli enti
       * @return {Promise} - Ritorna una promise contenente l'oggetto dominio degli enti di rilascio
       */
      this.promiseRecuperaDominiEntiRilascio = function (tipoDocumento, paeseEmissione) {
        var queryParamsObj = {};

        if (tipoDocumento) {
          queryParamsObj.tipoDocumento = tipoDocumento;
        }
        if (paeseEmissione) {
          queryParamsObj.paeseEmissione = paeseEmissione;
        }

        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.DOCUMENTO.ENTE_RILASCIO,
          params: queryParamsObj
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaAnagrafica
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare i dati dell'anagrafica della pratica
       * @return {Promise} - Ritorna una promise contenente l'oggetto anagrafica collegato alla pratica
       */
      this.promiseRecuperaAnagraficaPic = function (ndg) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.ANAGRAFICA.DETTAGLIO_ANA + ndg
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaDatiAggiuntivi
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare i dati aggiuntivi salvati per l'anagrafica
       * @return {Promise} - Ritorna una promise contenente i dati aggiuntivi collegati alla pratica
       */
      this.promiseRecuperaDatiAggiuntivi = function (ndg) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.ANAGRAFICA.DETTAGLIO + ndg + CONSTANTS.REST.PRATICA.DATI_AGGIUNTIVI
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaTipoCarta
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare i dati aggiuntivi salvati per l'anagrafica
       * @return {Promise} - Ritorna una promise contenente i dati aggiuntivi collegati alla pratica
       */
      this.promiseRecuperaTipoCarta = function (idProdotto) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.TIPO_CARTA + idProdotto
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaTipoCartaPerIdPratica
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare i dati aggiuntivi salvati per l'anagrafica
       * @return {Promise} - Ritorna una promise contenente i dati aggiuntivi collegati alla pratica
       */
      this.promiseRecuperaProdottoPerIdPratica = function (idPratica) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.TIPO_CARTA_PER_ID + idPratica
        });
      };

      /**
       * @ngdoc method
       * @name promiseDatiAml
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per eseguire la conferma dell'indirizzo di spedizione
       * @return {Promise} - Ritorna una promise contenente l'oggetto pratica collegato all'ID
       */
      this.promiseDatiAml = function (idPratica, datiAml, prosegui) {
        var paramsObj = {
          prosegui: prosegui
        };

        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO + idPratica + CONSTANTS.REST.PRATICA.DATI_AML,
          data: datiAml,
          params: paramsObj
        });
      };

      /**
       * @ngdoc method
       * @name promiseDatiAggiuntivi
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per eseguire la conferma dell'indirizzo di spedizione
       * @return {Promise} - Ritorna una promise contenente l'oggetto pratica collegato all'ID
       */
      this.promiseDatiAggiuntivi = function (idPratica, datiAggiuntivi, prosegui, sottostep) {
        var paramsObj = {
          prosegui: prosegui
        };

        // aggiungo nei dati aggiuntivi anche il tipoCarta
        if (!datiAggiuntivi.tipoCarta) datiAggiuntivi.tipoCarta = self.currentTipoCarta;

        if (sottostep && sottostep > 0) {
          paramsObj.sottostep = sottostep;
        }

        return this.$http({
          method: 'PUT',
          url:
            CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO + idPratica + CONSTANTS.REST.PRATICA.DATI_AGGIUNTIVI,
          data: datiAggiuntivi,
          params: paramsObj
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaQuestionariNexi
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare i questionari associati alla pratica
       * @return {Promise} - Ritorna una promise contenente l'elenco dei questionari, compilati o meno, per la pratica
       */
      this.promiseRecuperaQuestionariNexi = function (idPratica) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.QUESTIONARI.NEXI + idPratica
        });
      };

      /**
       * @ngdoc method
       * @name promiseSaveQuestionari
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per salvare i questionari compilati dall'utente
       * @return {Promise} - Ritorna una promise contenente la conferma o meno del salvataggio
       */
      this.promiseSaveQuestionari = function (idPratica, questionari, prosegui) {
        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO + idPratica + CONSTANTS.REST.PRATICA.QUESTIONARI,
          data: {
            idPratica: idPratica,
            questionari: questionari
          },
          params: {
            prosegui: prosegui
          }
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaConfigurazioneCampi
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare la configurazione personalizzata dei campi per istituto
       * @return {Promise} - Ritorna una promise contenente la configurazione campi personalizzata
       */
      this.promiseRecuperaConfigurazioneCampi = function (nomeConfigurazione, ndg) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.FIELDCONFIGURATOR + nomeConfigurazione + '/' + ndg
        });
      };

      /**
       * @ngdoc method
       * @name promiseCompletaPratica
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua la chiamata per avviare il completamento della pratica
       * @return {Promise} - Ritorna una promise contenente la pratica aggiornata
       */
      this.promiseCompletaPratica = function (idPratica) {
        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO + idPratica + CONSTANTS.REST.PRATICA.COMPLETA,
          data: {
            idPratica: idPratica
          }
        });
      };

      /**
       * @ngdoc method
       * @name promiseProspettoPersonaFisica
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua la chiamata per avviare il completamento della pratica
       * @return {Promise} - Ritorna una promise contenente la pratica aggiornata
       */
      this.promiseProspettoPersonaFisica = function (idPratica) {
        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.PROSPETTOPERSONAFISICA + idPratica,
          data: {
            idPratica: idPratica
          }
        });
      };

      /**
       * @ngdoc method
       * @name promiseAccettazionePratica
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua la chiamata per avviare il completamento della pratica
       * @return {Promise} - Ritorna una promise contenente la pratica aggiornata
       */
      this.promiseAccettazionePratica = function (datiProspetto) {
        return this.$http({
          method: 'POST',
          url: CONSTANTS.REST_PROSPECTMANAGER_ROOT + CONSTANTS.REST.ACCETTAZIONE,
          data: {
            idPratica: datiProspetto.idProspetto,
            nota: datiProspetto.nota
          }
        });
      };

      /**
       * @ngdoc method
       * @name promiseAnnullaPratica
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua la chiamata per avviare l'annullamento della pratica
       * @return {Promise} - Ritorna una promise contenente la pratica aggiornata
       */
      this.promiseAnnullaPratica = function (idPratica, note) {
        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO + idPratica + CONSTANTS.REST.PRATICA.ANNULLA,
          data: note
        });
      };

      /**
       * @ngdoc method
       * @name promiseRifiutaPratica
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua la chiamata per avviare il rifiuto della pratica
       * @return {Promise} - Ritorna una promise contenente la pratica aggiornata
       */
      this.promiseRifiutaPratica = function (idPratica, note) {
        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO + idPratica + CONSTANTS.REST.PRATICA.RIFIUTA,
          data: note
        });
      };

      /**
       * @ngdoc method
       * @name promiseDettaglioPratica
       * @methodOf cbl.cartadebitoint.wa.directive:PostVenditaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare il dettaglio pratoca
       * @return {Promise} - Ritorna una promise contenente l'oggetto pratica collegato all'ID
       */
      this.promiseDettaglioContoCorrente = function (idPratica) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.CONTOCORRENTE.replace('{idPratica}', idPratica)
        });
      };

      /**
       * @ngdoc funzione di utility per scorporo civico da indirizzo
       * @name promiseAnnullaPratica
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua la chiamata per avviare l'annullamento della pratica
       * @return {Promise} - Ritorna una promise contenente la pratica aggiornata
       */
      this.getStreetNumber = function (address) {
        var r = /\d+/;

        var regex = address.match(r);
        if (regex && Array.isArray(regex) && regex.length)
          return {
            indirizzo: address.substring(0, regex.index),
            civico: address.substring(regex.index, address.length)
          };
        else return null;
      };

      this.checkComma = function (via){
    	if(!via){
    		return null;
    	}
    	via = via.trim();
      	if (via.endsWith(',')) {
      		return self.checkComma(via.slice(0, -1));
  		}
  		return via;
      }
      
      /**
       * @ngdoc method
       * @name promiseVerificaPresaInCarico
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua la chiamata per verificare se la pratica è gia' presa in carico
       * @return {Promise} - Ritorna una promise contenente true/false
       */
      this.promiseVerificaPresaInCarico = function (idPratica) {
        return this.$http({
          method: 'GET',
          url:
            CONSTANTS.REST_ROOT +
            CONSTANTS.REST.PRATICA.DETTAGLIO +
            idPratica +
            CONSTANTS.REST.PRATICA.VERIFICAPRESAINCARICO,
          data: {
            idPratica: idPratica
          }
        });
      };

      /**
       * @ngdoc method
       * @name promisePrendiInCarico
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua la chiamata per prendere in carico la pratica
       * @return {Promise} - Ritorna una promise contenente la pratica aggiornata
       */
      this.promisePrendiInCarico = function (idPratica) {
        return this.$http({
          method: 'PUT',
          url:
            CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO + idPratica + CONSTANTS.REST.PRATICA.PRENDIINCARICO,
          data: {
            idPratica: idPratica
          }
        });
      };

      /**
       * @ngdoc method
       * @name promiseRilasciaPratica
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua la chiamata per rilasciare la pratica
       * @return {Promise} - Ritorna una promise contenente la pratica aggiornata
       */
      this.promiseRilasciaPratica = function (idPratica) {
        return this.$http({
          method: 'PUT',
          url:
            CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO + idPratica + CONSTANTS.REST.PRATICA.RILASCIAPRATICA,
          data: {
            idPratica: idPratica
          }
        });
      };

      this.promiseCheckIbanAndConfermaProdotto = function (iban) {
        return this.$http({
          method: 'POST',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.VERIFICA_CONTO_LIGHT,
          data: iban
        });
      };
    }
  ]);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/cdintPropostaCartaDebitoInt/cdintPropostaCartaDebitoIntSrvc.js
// module id = 13
// module chunks = 0